var render, staticRenderFns
import script from "./WxTextField.vue?vue&type=script&lang=js"
export * from "./WxTextField.vue?vue&type=script&lang=js"
import style0 from "./WxTextField.vue?vue&type=style&index=0&id=46cdee86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cdee86",
  null
  
)

export default component.exports